import { useQuery} from '@apollo/client';
import { Queries } from "./common_queries";

export const NoResultProperties = (status, department) => {
    return useQuery(Queries.NoResultProperties, {
        variables: {status: status, department: department}
    });
}